import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: '[fxH], cbre-fx-horizontal',
  template: `<ng-content></ng-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class FxHorizontalLayoutComponent {
  @HostBinding('class') fxClass = 'fx--h';
}
